export const reverseDictionary = (dictionary: Object) =>
  Object.fromEntries(Object.entries(dictionary).map(([a, b]) => [b, a]));
